import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, db } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import useAdmin from '../hooks/useAdmin';
import './Header.css';

export default function Header() {
  const navigate = useNavigate();
  const [user] = useAuthState(auth);
  const { isAdmin, loading } = useAdmin();
  const [isMusician, setIsMusician] = useState(false);

  useEffect(() => {
    const checkIfMusician = async () => {
      if (user) {
        const q = query(collection(db, 'Musiciens'), where('userId', '==', user.uid));
        const snapshot = await getDocs(q);
        setIsMusician(!snapshot.empty);
      }
    };

    checkIfMusician();
  }, [user]);

  const handleLogout = () => {
    auth.signOut();
    navigate('/');
  };

  return (
    <header className="header">
      <h2>Gates of Music</h2>
      <nav>
        {user ? (
          <>
            <span style={{ color: '#ff9800', marginRight: '16px' }}>
              Bonjour, {user.displayName || user.email}
            </span>

            {isMusician && (
              <button
                className="admin-button"
                onClick={() => navigate('/mon-profil')}
                aria-label="Accéder à mon profil"
              >
                Mon profil
              </button>
            )}

            {!loading && isAdmin && (
              <button
                className="admin-button"
                onClick={() => navigate('/add-booking-dates')}
                aria-label="Accéder à la page d'ajout de dates de booking"
              >
                Booking
              </button>
            )}

            <button onClick={handleLogout} aria-label="Se déconnecter">
              Se déconnecter
            </button>
          </>
        ) : (
          <>
            <button onClick={() => navigate('/auth?mode=signup')} aria-label="Créer un compte">
              Créer mon compte
            </button>
            <button
              className="orange"
              onClick={() => navigate('/auth?mode=login')}
              aria-label="Se connecter"
            >
              Me connecter
            </button>
          </>
        )}
      </nav>
    </header>
  );
}
